module.exports = __webpack_public_path__ + "static/media/emilgif.4b75aebe.gif";